var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"of-second-background"},[_c('oc-section',{attrs:{"sectionId":"ma","title":"Mujeres Adas sin \"H\"","tabsContent":_vm.tabsContent,"nextRef":"#eventos","inverted":"inverted"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cded6cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/Section4.vue
// module id = 69
// module chunks = 0